

import {
    Activity,
    Airplay,
    AlertCircle,
    AlertOctagon,
    AlertTriangle,
    AlignCenter,
    AlignJustify,
    AlignLeft,
    AlignRight,
    Anchor,
    Aperture,
    Archive,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    AtSign,
    Award,
    BarChart,
    BarChart2,
    Battery,
    BatteryCharging,
    Bell,
    BellOff,
    Book,
    Bookmark,
    BookOpen,
    Box,
    Briefcase,
    Calendar,
    Camera,
    CameraOff,
    Cast,
    Check,
    CheckCircle,
    CheckSquare,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleChevronDown,
    Clipboard,
    Clock,
    Cloud,
    CloudDrizzle,
    CloudLightning,
    CloudOff,
    CloudRain,
    CloudSnow,
    Code,
    Codepen,
    Codesandbox,
    Coffee,
    Columns,
    Command,
    Compass,
    Copy,
    CornerDownLeft,
    CornerDownRight,
    CornerLeftDown,
    CornerLeftUp,
    CornerRightDown,
    CornerRightUp,
    CornerUpLeft,
    CornerUpRight,
    Cpu,
    CreditCard,
    Crop,
    Crosshair,
    Database,
    Delete,
    Disc,
    Divide,
    DivideCircle,
    DivideSquare,
    DollarSign,
    Download,
    DownloadCloud,
    Dribbble,
    Droplet,
    Edit,
    Edit2,
    Edit3,
    ExternalLink,
    Eye,
    EyeOff,
    Facebook,
    FastForward,
    Feather,
    Figma,
    File,
    FileMinus,
    FilePlus,
    FileText,
    Film,
    Filter,
    Flag,
    Folder,
    FolderMinus,
    FolderPlus,
    Framer,
    Frown,
    Gift,
    GitBranch,
    GitCommit,
    Github,
    Gitlab,
    GitMerge,
    GitPullRequest,
    Globe,
    Grid,
    HardDrive,
    Hash,
    Headphones,
    Heart,
    HelpCircle,
    Hexagon,
    Home,
    Image,
    Inbox,
    Info,
    Instagram,
    Italic,
    Key,
    Layers,
    Layout,
    LifeBuoy,
    Link,
    Link2,
    Linkedin,
    List,
    Loader,
    Lock,
    LogIn,
    LogOut,
    Mail,
    Map as MapIcon,
    MapPin,
    Maximize,
    Maximize2,
    Meh,
    Menu,
    MessageCircle,
    MessageSquare,
    Mic,
    MicOff,
    Minimize,
    Minimize2,
    Minus,
    MinusCircle,
    MinusSquare,
    Search,
    ToggleLeft,
    User,
    UsersRound,
} from "lucide-react";

export const LUCIDE_ICONS_LIST = [
  { name: "Activity", element: Activity },
  { name: "Airplay", element: Airplay },
  { name: "AlertCircle", element: AlertCircle },
  { name: "AlertOctagon", element: AlertOctagon },
  { name: "AlertTriangle", element: AlertTriangle },
  { name: "AlignCenter", element: AlignCenter },
  { name: "AlignJustify", element: AlignJustify },
  { name: "AlignLeft", element: AlignLeft },
  { name: "AlignRight", element: AlignRight },
  { name: "Anchor", element: Anchor },
  { name: "Aperture", element: Aperture },
  { name: "Archive", element: Archive },
  { name: "ArrowDown", element: ArrowDown },
  { name: "ArrowLeft", element: ArrowLeft },
  { name: "ArrowRight", element: ArrowRight },
  { name: "ArrowUp", element: ArrowUp },
  { name: "AtSign", element: AtSign },
  { name: "Award", element: Award },
  { name: "BarChart", element: BarChart },
  { name: "BarChart2", element: BarChart2 },
  { name: "Battery", element: Battery },
  { name: "BatteryCharging", element: BatteryCharging },
  { name: "Bell", element: Bell },
  { name: "BellOff", element: BellOff },
  { name: "Book", element: Book },
  { name: "Bookmark", element: Bookmark },
  { name: "BookOpen", element: BookOpen },
  { name: "Box", element: Box },
  { name: "Briefcase", element: Briefcase },
  { name: "Calendar", element: Calendar },
  { name: "Camera", element: Camera },
  { name: "CameraOff", element: CameraOff },
  { name: "Cast", element: Cast },
  { name: "CircleChevronDown", element: CircleChevronDown },
  { name: "Check", element: Check },
  { name: "CheckCircle", element: CheckCircle },
  { name: "CheckSquare", element: CheckSquare },
  { name: "ChevronDown", element: ChevronDown },
  { name: "ChevronLeft", element: ChevronLeft },
  { name: "ChevronRight", element: ChevronRight },
  { name: "ChevronUp", element: ChevronUp },
  { name: "Clipboard", element: Clipboard },
  { name: "Clock", element: Clock },
  { name: "Cloud", element: Cloud },
  { name: "CloudDrizzle", element: CloudDrizzle },
  { name: "CloudLightning", element: CloudLightning },
  { name: "CloudOff", element: CloudOff },
  { name: "CloudRain", element: CloudRain },
  { name: "CloudSnow", element: CloudSnow },
  { name: "Code", element: Code },
  { name: "Codepen", element: Codepen },
  { name: "Codesandbox", element: Codesandbox },
  { name: "Coffee", element: Coffee },
  { name: "Columns", element: Columns },
  { name: "Command", element: Command },
  { name: "Compass", element: Compass },
  { name: "Copy", element: Copy },
  { name: "CornerDownLeft", element: CornerDownLeft },
  { name: "CornerDownRight", element: CornerDownRight },
  { name: "CornerLeftDown", element: CornerLeftDown },
  { name: "CornerLeftUp", element: CornerLeftUp },
  { name: "CornerRightDown", element: CornerRightDown },
  { name: "CornerRightUp", element: CornerRightUp },
  { name: "CornerUpLeft", element: CornerUpLeft },
  { name: "CornerUpRight", element: CornerUpRight },
  { name: "Cpu", element: Cpu },
  { name: "CreditCard", element: CreditCard },
  { name: "Crop", element: Crop },
  { name: "Crosshair", element: Crosshair },
  { name: "Database", element: Database },
  { name: "Delete", element: Delete },
  { name: "Disc", element: Disc },
  { name: "Divide", element: Divide },
  { name: "DivideCircle", element: DivideCircle },
  { name: "DivideSquare", element: DivideSquare },
  { name: "DollarSign", element: DollarSign },
  { name: "Download", element: Download },
  { name: "DownloadCloud", element: DownloadCloud },
  { name: "Dribbble", element: Dribbble },
  { name: "Droplet", element: Droplet },
  { name: "Edit", element: Edit },
  { name: "Edit2", element: Edit2 },
  { name: "Edit3", element: Edit3 },
  { name: "ExternalLink", element: ExternalLink },
  { name: "Eye", element: Eye },
  { name: "EyeOff", element: EyeOff },
  { name: "Facebook", element: Facebook },
  { name: "FastForward", element: FastForward },
  { name: "Feather", element: Feather },
  { name: "Figma", element: Figma },
  { name: "File", element: File },
  { name: "FileMinus", element: FileMinus },
  { name: "FilePlus", element: FilePlus },
  { name: "FileText", element: FileText },
  { name: "Film", element: Film },
  { name: "Filter", element: Filter },
  { name: "Flag", element: Flag },
  { name: "Folder", element: Folder },
  { name: "FolderMinus", element: FolderMinus },
  { name: "FolderPlus", element: FolderPlus },
  { name: "Framer", element: Framer },
  { name: "Frown", element: Frown },
  { name: "Gift", element: Gift },
  { name: "GitBranch", element: GitBranch },
  { name: "GitCommit", element: GitCommit },
  { name: "GitMerge", element: GitMerge },
  { name: "GitPullRequest", element: GitPullRequest },
  { name: "Github", element: Github },
  { name: "Gitlab", element: Gitlab },
  { name: "Globe", element: Globe },
  { name: "Grid", element: Grid },
  { name: "HardDrive", element: HardDrive },
  { name: "Hash", element: Hash },
  { name: "Headphones", element: Headphones },
  { name: "Heart", element: Heart },
  { name: "HelpCircle", element: HelpCircle },
  { name: "Hexagon", element: Hexagon },
  { name: "Home", element: Home },
  { name: "Image", element: Image },
  { name: "Inbox", element: Inbox },
  { name: "Info", element: Info },
  { name: "Instagram", element: Instagram },
  { name: "Italic", element: Italic },
  { name: "Key", element: Key },
  { name: "Layers", element: Layers },
  { name: "Layout", element: Layout },
  { name: "LifeBuoy", element: LifeBuoy },
  { name: "Link", element: Link },
  { name: "Link2", element: Link2 },
  { name: "Linkedin", element: Linkedin },
  { name: "List", element: List },
  { name: "Loader", element: Loader },
  { name: "Lock", element: Lock },
  { name: "LogIn", element: LogIn },
  { name: "LogOut", element: LogOut },
  { name: "Mail", element: Mail },
  { name: "Map", element: MapIcon },
  { name: "MapPin", element: MapPin },
  { name: "Maximize", element: Maximize },
  { name: "Maximize2", element: Maximize2 },
  { name: "Meh", element: Meh },
  { name: "Menu", element: Menu },
  { name: "MessageCircle", element: MessageCircle },
  { name: "MessageSquare", element: MessageSquare },
  { name: "Mic", element: Mic },
  { name: "MicOff", element: MicOff },
  { name: "Minimize", element: Minimize },
  { name: "Minimize2", element: Minimize2 },
  { name: "Minus", element: Minus },
  { name: "MinusCircle", element: MinusCircle },
  { name: "MinusSquare", element: MinusSquare },
  { name: "Search", element: Search },
  { name: "ToggleLeft", element: ToggleLeft },
  { name: "User", element: User },
  { name: "UsersRound", element: UsersRound },
];
